angular.module('sdbgui')
.filter 'filterFields', () ->
  (items, term, fields) ->
    if !term
      # no search term - return everything
      return items

    term = term.toLowerCase();

    output = []

    for item in items
      # if any of fields matches
      for f in fields
        if item[f] && item[f].toLowerCase().includes(term)
          output.push(item)
          break

    return output
